import { render, staticRenderFns } from "./cgu.vue?vue&type=template&id=7bc0e2ec&scoped=true&"
import script from "./cgu.vue?vue&type=script&lang=js&"
export * from "./cgu.vue?vue&type=script&lang=js&"
import style0 from "./cgu.vue?vue&type=style&index=0&id=7bc0e2ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bc0e2ec",
  null
  
)

export default component.exports